import _ from "lodash";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import useLabels from "../../../containers/FacilityDetailsPage/hooks/useLabels";
import useLocation from "../../../containers/FacilityDetailsPage/hooks/useLocation";
import { LabelData } from "../../../models/LabelData";
import OutsideClickHandler from "../../Common/OutsideClickHandler";
import PopupSelectLabels from "../PopupSelectLabels";

import "./styles.scss";

export interface ILabelsListProps {
  locationId: number;
  organizationId: string;
}

export const LabelsList: React.FunctionComponent<ILabelsListProps> = (
  props
) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityListPage.facilityList.${key}`);

  const { organizationId, locationId } = props;
  const [shownPopupSelectLabels, setShownPopupSelectLabels] =
    useState<boolean>(false);

  const { data: labels } = useLabels(
    _.pickBy({
      organization_id: organizationId,
    })
  );
  const { data: locationData } = useLocation(locationId);

  return (
    <>
      {labels && locationData && (
        <OutsideClickHandler
          onOutsideClick={() => {
            setShownPopupSelectLabels(false);
          }}
        >
          <div className="some-labels">
            {labels
              .filter((label) =>
                locationData.labels.some((l) => l.id === label.id)
              )
              .map((itemLabel: LabelData, indexLabel: number) => (
                <span className="items" key={indexLabel}>
                  {itemLabel.name}
                </span>
              ))}
            <div className="add-items-wrap">
              <button
                className="btn add-items"
                onClick={(event) => {
                  setShownPopupSelectLabels(!shownPopupSelectLabels);
                  event.preventDefault();
                }}
              >
                <span className="btn-add"></span>
                <span className="txt">{t("edit_labels")}</span>
              </button>
              {shownPopupSelectLabels && (
                <PopupSelectLabels
                  organizationId={organizationId}
                  locationId={locationId}
                  close={() => setShownPopupSelectLabels(false)}
                />
              )}
            </div>
          </div>
        </OutsideClickHandler>
      )}
    </>
  );
};

export default LabelsList;
